module.exports = __webpack_public_path__ + "img/C1.ec904653.png";